import React, { useEffect, useRef, useState } from "react";
import { TiArrowRightThick, TiArrowLeftThick } from "react-icons/ti";
import Card from "./component/Card";
import image from "../../Asset/feature/image.png";


const FeatureCategory = ({ item }) => {
  const scrollRef = useRef(null);

 

  const scroll = (direction) => {
    if (scrollRef.current) {
      const { scrollLeft, clientWidth } = scrollRef.current;
      const scrollAmount = clientWidth / 2;
      scrollRef.current.scrollTo({
        left:
          direction === "left"
            ? scrollLeft - scrollAmount
            : scrollLeft + scrollAmount,
        behavior: "smooth",
      });
    }
  };

  return (
    <div className="w-full bg-Background3" >
      <div className="py-7 px-4 md:px-12">
        {/* Header */}
        <div className="flex justify-between">
          <div className="flex flex-col">
            <span className="text-textColor text-lg md:text-3xl font-bold title">
              Featured Category
            </span>
            <span className="text-textColor text-base md:text-xl">
              Our best-selling categories of all time
            </span>
          </div>
          {/* Arrows (Only on sm and up) */}
          <div className="hidden sm:flex gap-4 sm:gap-6 text-3xl font-bold text-textColor">
            <div
              className="bg-textColor text-Background1 w-10 h-10 sm:w-11 sm:h-11 flex justify-center items-center rounded-full cursor-pointer"
              onClick={() => scroll("left")}
            >
              <TiArrowLeftThick />
            </div>
            <div
              className="bg-textColor text-Background1 w-10 h-10 sm:w-11 sm:h-11 flex justify-center items-center rounded-full cursor-pointer"
              onClick={() => scroll("right")}
            >
              <TiArrowRightThick />
            </div>
          </div>
        </div>

        {/* Cards Container */}
        <div className="mt-5 relative">
          {/* Mobile Swipe Scroll */}
          <div
            className="sm:hidden flex gap-4 overflow-x-auto scrollbar-hide scroll-smooth pb-3"
            ref={scrollRef}
          >
            {item?.map((item, index) => (
              <div key={index} className="w-[100%] flex-shrink-0 py-4">
                <Card item={item} />
              </div>
            ))}
          </div>

          {/* Grid Layout for sm and up */}
          <div
            className={`hidden sm:grid ${
              item?.length > 8 ? "grid-rows-2 grid-flow-col gap-4" : "grid-cols-2 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-4 2xl:grid-cols-5 gap-6 lg:gap-24  md:gap-20 2xl:gap-4"
            }  overflow-x-hidden py-6`}
            ref={scrollRef}
          >
            {item?.map((item, index) => (
              <div key={index} className="w-[300px] md:w-[250px] lg:w-[260px] xl:w-[350px]flex-shrink-0 ">
                <Card item={item} />
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* Footer Image */}
      <div className="w-full mt-2">
        <img src={image} className="w-full object-cover" alt="sho" />
      </div>
    </div>
  );
};

export default FeatureCategory;